module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/v2/something_went_wrong.307e46cf70050e8476043d11be6618cd.svg";